import React from 'react';
import { RouterOutlet } from 'ui/router';

export const indexPageView = () => {
    return (
        <div className='ui-view-index'>
            <RouterOutlet page='INDEX'/>
        </div>
    );
};

// set display name
indexPageView.displayName = 'indexPageView';

// set default props
indexPageView.defaultProps = {};
